import birthControl from './birth-control';
import promoEd from './promo-ed';
import facesheet from './facesheet';
import hair from './hair';
import promoHair from './promo-hair';
import hc from './hc';
import latisse from './latisse';
import qadam from './qadam';
import skin from './skin';
import smoking from './smoking';
import test from './test';
import transferRx from './tranfer-rx';
import trt from './trt';
import eczema from './eczema';
import skinTags from './skin-tags';
import scarring from './scarring';
import std from './std';
import generalHealth from './general-health';
import final from './final';
import planB from './planb';
import wlInitialMeet from './initial-meet';
import wlMealPlanning from './meal-planning';
import wlCheckIn from './check-in';
import checkInVisit from './check-in-visit';
import uti from './uti';
import wlProgress from './weight-loss-progress';
import wlWeekly from './weight-loss-weekly';
import allergies from './allergies';
import wlPhotos from './weight-loss-images';
import tripleHair from './triple-hair';
import refill from './refill';
import norefill from './norefill';
import intake from './intake';
import epds from './epds';
import phq from './phq-9';
import gad from './gad-7';
import wl1stSession from './wl1stSession';
import wlPhysical from './wlPhysical';
import WLPreSW from './WLPreSW';
import WLPreNP from './WLPreNP';
import wlPostLabCheck from './wlPostLabCheck';
import psycho from './psycho';
import CS_VC_coordinatorsConsent from './CS-VC-coordinatorsConsent';
import virtualCareConcerns from './virtualCareConcerns';
import sharingInfoConsent from './sharingInfoConsent';
import epipen from './epipen';
import gn from './gn-welcome';
import dass21 from './DASS21';
import pcl5 from './PCL5';
import bms_before from './BMS-before';
import bms_after from './BMS-after';
import esign from './esign';
import rda25 from './regestiered-dietian-25';
import rda50 from './regestiered-dietian-50';
import mha from './mental-health-app';
import rka25 from './regestiered-kinesiologist-25';
import rka50 from './regestiered-kinesiologist-50';
import endorIntake from './endor-intake';
import psychoFollowUp from './psychotherapy-follow-up';
import gn_intake from './gn-intake';
import kinesiologist_checkin from './kinesiologist-checkin';
import wl3months from './wl3months';
import wl6months from './wl6months';
import wl12months from './wl12months';
import wlMonthlyFollowup from './wlMonthlyFollowup';
import drugCard, {
  drug2Questions,
  drug3Questions,
  drug4Questions,
  drug5Questions
} from './drug-card-data';
import momwellConsentQuestions from './momwell-consent';
import momwellConsentQuestionsV2 from './momwell-consent-v2';
import momwellPatientHistory from './momwell-patient-history';
import momwellPartnerHistory from './momwell-partner-history';
import momwellIntakeNetwork from './momwell-intake-network';
import momwellIntakeCash from './momwell-intake-cash';
import hrt from './hrt';
import hrt1MonthFollowup from './hrt-1-month-followup';
import hrt3MonthsFollowup from './hrt-3-months-followup';
import hyperpig from './hyperpigmentation';
import rxrefill from './rx-refill';
import telehealthConsent from './telehealth-consent';
import ssrs from './columbia-c-ssrs-self-report';
import momwellConsentToDisclose from './momwell-consent-to-disclose';
import govIdUs from './govIdUs';
import selfieUs from './selfieUs';
import bodySelfieUs from './bodySelfieUs';
import femaleHRTBeluga from './HRT/femaleHRT';
import HairLossQuestions from './Hairloss/questions';
import EDQuestions from './Erectile Dysfunction/questions';
import PEQuestions from './Premature Ejaculation/questions';
import antiAgingQuestions from './Anti Aging/questions';
import acneQuestions from './Acne/questions';
import weightlossQuestions from './Weightloss/questions';
import libidoQuestions from './Libido/questions';
import weightManagementQuestions from './Weight Management/questions';
import { IQuestionModel } from '@care-portals/api-interfaces';
import sermorelinQuestions from './Sermorelin/questions';
import rectalHealthQuestions from './RectalHealth/questions';
import ecgQuestions from './ECG Monitior/questions';
import mensexhealthQuestions from './Mens Sexual Health/questions';
import prepQuestions from './PrEP/initial/prep';
import bummedQuestions from './Bummed/questions';
import alcoholQuestions from './Alcohol/questions';
import MicroGlp1Questions from './MicroDosing GLP-1/questions';
import SybilQuestions from './SybilHRT/questions';
import EnovoneTestosteroneIntake from './enovone-testosterone-intake';
import EnclomipheneQuestions from './Enclomiphene/questions';
import TravelKitQuestions from './TravelKit/questions';
import AntiNauseaQuestions from './AntiNausea/questions';
import ZaludQuestions from './Zalud/questions';
import ldnQuestions from './LDN/questions';
import trtQuestions from './TRT/questions';
import menopauseConsent from './menopause-consent';
import pocketpillsWaiver from './pocketpills-waiver';
import FacialAntiAgingQuestions from './Facial Anti Aging/questions';
import PeptideQuestions from './Peptide/questions';
import MigraineQuestions from './Migraine/questions';
import ModafinilQuestions from './Modafinil/questions';
import WeightLossCVQuestions from './Weight Loss CV/questions';
import GenericQuestions from './Generic/questions';
import LucenceCardioHemeRISKQuestions from './Lucence CardioHemeRISK/questions';
import pcosQuestions from './PCOS/questions';
import TestosteroneSupportEdQuestions from './Testosterone Support Ed/questions';
import SuboxoneQuestions from './Suboxone/questions';
import MdiQuestions from './MDI/questions';

const questionGroups: ReadonlyArray<ReadonlyArray<unknown>> = [
  EnovoneTestosteroneIntake,
  birthControl,
  promoEd,
  facesheet,
  hair,
  promoHair,
  hc,
  latisse,
  qadam,
  skin,
  smoking,
  test,
  transferRx,
  trt,
  eczema,
  weightlossQuestions,
  skinTags,
  scarring,
  std,
  generalHealth,
  final,
  planB,
  wlInitialMeet,
  wlMealPlanning,
  wlCheckIn,
  checkInVisit,
  uti,
  wlProgress,
  wlWeekly,
  allergies,
  wlPhotos,
  tripleHair,
  refill,
  norefill,
  intake,
  epds,
  phq,
  gad,
  wl1stSession,
  wlPhysical,
  WLPreSW,
  WLPreNP,
  wlPostLabCheck,
  psycho,
  CS_VC_coordinatorsConsent,
  virtualCareConcerns,
  sharingInfoConsent,
  epipen,
  gn,
  dass21,
  pcl5,
  bms_before,
  bms_after,
  esign,
  rda25,
  rda50,
  mha,
  rka25,
  rka50,
  endorIntake,
  psychoFollowUp,
  gn_intake,
  kinesiologist_checkin,
  wl3months,
  wl6months,
  wl12months,
  wlMonthlyFollowup,
  drugCard,
  drug2Questions,
  drug3Questions,
  drug4Questions,
  drug5Questions,
  momwellConsentQuestions,
  momwellConsentQuestionsV2,
  momwellPatientHistory,
  momwellPartnerHistory,
  hrt,
  hrt1MonthFollowup,
  hrt3MonthsFollowup,
  hyperpig,
  momwellIntakeNetwork,
  momwellIntakeCash,
  rxrefill,
  telehealthConsent,
  ssrs,
  momwellConsentToDisclose,
  HairLossQuestions,
  EDQuestions,
  PEQuestions,
  govIdUs,
  selfieUs,
  bodySelfieUs,
  femaleHRTBeluga,
  antiAgingQuestions,
  acneQuestions,
  libidoQuestions,
  sermorelinQuestions,
  rectalHealthQuestions,
  ecgQuestions,
  weightManagementQuestions,
  mensexhealthQuestions,
  prepQuestions,
  bummedQuestions,
  alcoholQuestions,
  MicroGlp1Questions,
  SybilQuestions,
  EnclomipheneQuestions,
  TravelKitQuestions,
  AntiNauseaQuestions,
  ZaludQuestions,
  ldnQuestions,
  trtQuestions,
  menopauseConsent,
  pocketpillsWaiver,
  FacialAntiAgingQuestions,
  GenericQuestions,
  pcosQuestions,
  SuboxoneQuestions,
  LucenceCardioHemeRISKQuestions,
  TestosteroneSupportEdQuestions,
  PeptideQuestions,
  MigraineQuestions,
  ModafinilQuestions,
  WeightLossCVQuestions,
  MdiQuestions,
];

export const QuestionsCatalog = questionGroups.flat() as IQuestionModel[];
